module.exports = __webpack_public_path__ + "img/icon_save.c5d1c42f.png";